import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { GalleryService } from 'src/app/services/gallery.service';
import { ToastrService } from 'ngx-toastr';
import { StihlGalleryDataDTO, StihlGalleryDataLogDTO } from 'src/app/models/stihl-gallery-dto';
import { environment } from 'src/environments/environment';
import { visibleContentAnimation } from 'src/app/animations';
import { heightContentAnimation } from 'src/app/animations';
import { StihlFileDTO } from 'src/app/models/stihl-file-dto';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { WelcomeService } from 'src/app/services/welcome.service';
import { Router } from '@angular/router';
import { GalleryDataService } from 'src/app/services/gallery-data.service';
import { LogType } from 'src/app/enums/logType';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  animations: [visibleContentAnimation, heightContentAnimation]
})

export class GalleryComponent implements OnInit {
  @Input() galleries: StihlGalleryDataDTO[];
  pathVideo = environment.urlApiVideos;
  constructor(private service: GalleryDataService, private router: Router) { }
  ngOnInit(): void {
  }

  downloadFileView(file: StihlFileDTO, view = false) {

    Swal.fire({
      icon: 'info',
      title: 'A fazer o download',
      text: 'Aguarde por favor…'
    });
    Swal.showLoading();
    this.service.getFile(file).subscribe((fileDoc) => {
      if (view) {
        const url = URL.createObjectURL(fileDoc);
        window.open(url, '_blank');
      } else {
        saveAs(fileDoc, file.FileName);
      }

      Swal.close();

    });
  }

  openLink(item) {
    if (item.Url != null && item.Url != "") {
      const target = item.UrlOpenNew ? '_blank' : '_self';
      if (item.ExternalUrl) {
        // Navegación externa
        window.open(item.Url, target);
      } else {
        // Navegación interna
        if (item.UrlOpenNew) {
          window.open(window.location.origin + item.Url, target);
        } else {
          this.router.navigate([item.Url]);
        }
      }
    }
  }

  PostLog(idData: string) {
    console.log('entra')
    var dto = new StihlGalleryDataLogDTO(idData, LogType.Download);
    this.service.InsertLog(dto).subscribe({});

  }
}
